import { render, staticRenderFns } from "./SettingsAddress.vue?vue&type=template&id=249dff60&scoped=true"
import script from "./SettingsAddress.vue?vue&type=script&lang=js"
export * from "./SettingsAddress.vue?vue&type=script&lang=js"
import style0 from "./SettingsAddress.vue?vue&type=style&index=0&id=249dff60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249dff60",
  null
  
)

export default component.exports